import React from 'react';
import { UpCircleOutlined, DownCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { Tooltip } from '../../../../../../../components';

export const getCriteriaIcon = (criteria) => {
    const iconMap = {
        undersized: (
            <Tooltip className="table-criteria-icon" title="Undersized" placement="right">
                <DownCircleOutlined style={{ color: `var(--amber-default)` }} />
            </Tooltip>
        ),
        oversized: (
            <Tooltip className="table-criteria-icon" title="Oversized" placement="right">
                <UpCircleOutlined style={{ color: `var(--amber-default)` }} />
            </Tooltip>
        ),
        ready: (
            <Tooltip className="table-criteria-icon" title="Optimized" placement="right">
                <CheckCircleOutlined style={{ color: `var(--color-success)` }} />
            </Tooltip>
        ),
        can_modernize_os: (
            <Tooltip className="table-criteria-icon" title="OS Modernization Available" placement="right">
                <UpCircleOutlined style={{ color: `var(--amber-default)` }} />
            </Tooltip>
        ),
    };
    return iconMap[criteria] || null;
};
